import React, { useState } from 'react';
import {
  Button, Dialog, DialogContent, DialogTitle, Typography,
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import GedChat from './index';
import { themeExpert } from '../../theme/expert';

/** Quatre départs possibles, quand rien n'est configuré pour l'organisation. */
const DEPARTS = [
  { label: 'Tâches ouvertes',
    prompt: "Quelles sont les tâches ouvertes (non terminées) sur ce dossier ? Liste-les avec leur destinataire." },
  { label: 'Courrier de suivi',
    prompt: "Prépare un courrier de suivi après rendez-vous pour le client, résumant la situation du dossier." },
  { label: 'Analyser le contrat',
    prompt: "Analyse le contrat de ce dossier et signale les points de garantie importants." },
  { label: 'Proposer des tâches',
    prompt: "Propose-moi des tâches pertinentes à créer pour faire avancer ce dossier." },
];

/**
 * Le bouton qui ouvre l'assistant.
 *
 * `expertiseId` pour l'assistant d'un dossier, `documentUnitId` pour celui
 * d'un document.
 */
export default function GedChatButton({
  expertiseId = null,
  documentUnitId = null,
  label = 'Assistant',
  variant = 'contained',
  quickActions,
}) {
  const [ouvert, setOuvert] = useState(false);
  const [session, setSession] = useState(null);

  const actions = quickActions || (expertiseId ? DEPARTS : []);

  return (
    <>
      <Button variant={variant} onClick={() => setOuvert(true)}>{label}</Button>

      <ThemeProvider theme={themeExpert}>
        <Dialog open={ouvert} onClose={() => setOuvert(false)}
                fullWidth maxWidth="md">
          <DialogTitle sx={{ pb: 0 }}>
            {label}
            <Typography variant="caption" color="text.secondary"
                        component="div">
              Il répond à partir des pièces du dossier, et ne crée rien sans
              votre confirmation.
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            {/* Monté seulement à l'ouverture : la session ne s'ouvre pas
                tant que personne ne l'a demandée. */}
            {ouvert && (
              <GedChat
                expertiseId={expertiseId}
                documentUnitId={documentUnitId}
                sessionId={session}
                onSessionCreated={setSession}
                quickActions={actions}
                emptyHint="Posez une question sur ce dossier, ou partez d'une des propositions ci-dessus."
              />
            )}
          </DialogContent>
        </Dialog>
      </ThemeProvider>
    </>
  );
}
